(function(window, document) {
  'use strict';

  var observer;
  var initialized = false;
  var sectionSelector = '[data-preload]';

  var triggers = {
    bestseller: function() {
      window.HoshikiLanding && window.HoshikiLanding.fetchBestseller();
    },
    gem: function() {
      loadScripts(['tarot', 'utils', 'data', 'palette', 'gem']).then(function() {
        if (window.hoshikiGemProduct) {
          document.dispatchEvent(new Event('hoshikiGemsLoaded'));
        }
      });
    },
    diagnosis: function() {
      /* hoshiki-new-landing は custom_landing.js が診断を担当するため、personal-diagnosis の init をスキップ */
      if (document.getElementById('hoshiki-diagnosis') && document.getElementById('mbti-slot-machine')) {
        loadScripts(['tarot', 'utils', 'data']).then(function() {
          if (window.hoshikiGemProduct) {
            document.dispatchEvent(new Event('hoshikiGemsLoaded'));
          }
        });
        return;
      }
      loadScripts(['tarot', 'utils', 'data', 'personal_diagnosis']).then(function() {
        if (window.hoshikiGemProduct && window.hoshikiGemProduct.variants && window.hoshikiGemProduct.variants.edges
            && window.HoshikiDiagnosis && window.HoshikiDiagnosis.init && window.HoshikiData && window.HoshikiData.translations) {
          var variants = window.hoshikiGemProduct.variants.edges.map(function(e) { return e.node; });
          var lang = document.documentElement.lang.startsWith('zh') ? 'zh' : (document.documentElement.lang.split('-')[0] || 'ja');
          window.HoshikiDiagnosis.init(variants, window.HoshikiData.translations, lang);
        }
      });
    },
    concierge: function() {
      loadScripts(['palette', 'concierge']);
    }
  };

  var scriptKeyMap = {
    tarot: 'tarot',
    utils: 'utils',
    data: 'data',
    palette: 'palette',
    gem: 'gem',
    personal_diagnosis: 'diagnosis',
    concierge: 'concierge',
    controller: 'controller',
    landing: 'landing'
  };

  function loadScripts(keys) {
    if (!window.HoshikiLanding || !window.HoshikiLanding.loadScript) return Promise.resolve();
    var promises = keys.map(function(key) {
      var mapped = scriptKeyMap[key] || key;
      return window.HoshikiLanding.loadScript(mapped);
    });
    return Promise.all(promises);
  }

  function logMetric(name) {
    try {
      var queue = window.hoshikiMetrics = window.hoshikiMetrics || [];
      queue.push({ event: name, ts: Date.now() });
    } catch (e) {}
  }

  function triggerPreload(target) {
    if (!target) return;
    var kind = target.getAttribute('data-preload');
    if (!kind || target.dataset.preloaded === '1') return;
    target.dataset.preloaded = '1';
    target.querySelectorAll('[data-preload-src]').forEach(function(el) {
      var preloadSrc = el.getAttribute('data-preload-src');
      if (!preloadSrc) return;
      var img = new Image();
      img.src = preloadSrc;
    });
    var handle = triggers[kind];
    if (handle) handle();
    logMetric('preload_' + kind);
  }

  function initObserver() {
    if (initialized) return;
    initialized = true;
    var sections = document.querySelectorAll(sectionSelector);
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach(triggerPreload);
      return;
    }

    observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          triggerPreload(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '300px 0px 300px 0px' });

    sections.forEach(function(section) {
      observer.observe(section);
    });

    var idleLoad = function() {
      loadScripts(['tarot', 'utils', 'data']);
    };
    if (typeof requestIdleCallback !== 'undefined') {
      requestIdleCallback(idleLoad, { timeout: 2000 });
    } else {
      setTimeout(idleLoad, 1000);
    }
  }

  document.addEventListener('DOMContentLoaded', initObserver);
  window.HoshikiPreload = {
    trigger: triggerPreload,
    loadScripts: loadScripts
  };
})(window, document);
